import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

function NewsletterUnsubscribe() {
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const unsubscribe = async () => {
            try {
                const res = await fetch(`/api/newsletter/unsubscribe/${token}`);
                const data = await res.json();

                if (res.ok) {
                    setSuccess(true);
                } else {
                    setError(data.error || 'Der Abmeldelink ist ungueltig.');
                }
            } catch (err) {
                setError('Ein Fehler ist aufgetreten.');
            }
            setLoading(false);
        };

        unsubscribe();
    }, [token]);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-body p-4 text-center">
                            {loading && (
                                <div>
                                    <div className="spinner-border text-primary mb-3" role="status">
                                        <span className="visually-hidden">Laden...</span>
                                    </div>
                                    <p>Abmeldung wird verarbeitet...</p>
                                </div>
                            )}

                            {success && (
                                <div>
                                    <div className="text-success mb-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                        </svg>
                                    </div>
                                    <h2>Abmeldung erfolgreich</h2>
                                    <p className="text-muted mb-4">
                                        Du wurdest erfolgreich vom Newsletter abgemeldet und erhaeltst keine
                                        weiteren E-Mails von uns.
                                    </p>
                                    <p className="text-muted">
                                        Schade, dass du gehst! Falls du es dir anders ueberlegst, kannst du
                                        dich jederzeit wieder anmelden.
                                    </p>
                                    <Link to="/newsletter/subscribe" className="btn btn-outline-primary">
                                        Wieder anmelden
                                    </Link>
                                </div>
                            )}

                            {error && (
                                <div>
                                    <div className="text-danger mb-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                        </svg>
                                    </div>
                                    <h2 className="text-danger">Fehler</h2>
                                    <p className="text-muted mb-4">{error}</p>
                                    <Link to="/" className="btn btn-primary">
                                        Zur Startseite
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsletterUnsubscribe;
